<template>
  <!-- Sidebar -->
  <div class="sidebar" id="sidebar">
    <div class="sidebar-inner slimscroll">
      <perfect-scrollbar
        class="scroll-area"
        :settings="settings"
        @ps-scroll-y="scrollHanle"
      >
        <div id="sidebar-menu" class="sidebar-menu">
          <ul>
            <li :class="{ active: isActive('/provider/provider-dashboard') }">
              <router-link to="/provider/provider-dashboard">
                <i class="ti ti-layout-grid"></i><span>Dashboard</span>
              </router-link>
            </li>
            <li :class="{ active: isActive('/provider/provider-services') || isActive('/provider/provider-service-list') }">
              <router-link to="/provider/provider-services">
                <i class="ti ti-briefcase"></i><span>My Services</span>
              </router-link>
            </li>
            <li :class="{ active: isActive('/provider/provider-booking') }">
              <router-link to="/provider/provider-booking">
                <i class="ti ti-calendar-month"></i><span>Bookings</span>
              </router-link>
            </li>
            <li :class="{ active: isActive('/provider/staff-list') }">
              <router-link to="/provider/staff-list">
                <i class="ti ti-users"></i><span>Staffs</span>
              </router-link>
            </li>
            <li :class="{ active: isActive('/provider/customer-list') || isActive('/provider/customer-grid') }">
              <router-link to="/provider/customer-list">
                <i class="ti ti-user"></i><span>Customers</span>
              </router-link>
            </li>
            <li :class="{ active: isActive('/provider/provider-payout') || isActive('/provider/provider-transaction') }">
              <router-link to="/provider/provider-payout">
                <i class="ti ti-wallet"></i><span>Payout</span>
              </router-link>
            </li>
            <li :class="{ active: isActive('/provider/provider-holiday') }">
              <router-link to="/provider/provider-holiday">
                <i class="feather-calendar"></i><span>Holidays & Leave</span>
              </router-link>
            </li>
            <li :class="{ active: isActive('/provider/provider-coupons') }">
              <router-link to="/provider/provider-coupons">
                <i class="ti ti-ticket"></i><span>Coupons</span>
              </router-link>
            </li>
            <li :class="{ active: isActive('/provider/provider-offers') }">
              <router-link to="/provider/provider-offers">
                <i class="ti ti-square-percentage"></i><span>Offers</span>
              </router-link>
            </li>
            <li :class="{ active: isActive('/provider/provider-reviews') }">
              <router-link to="/provider/provider-reviews">
                <i class="ti ti-star"></i><span>Reviews</span>
              </router-link>
            </li>
            <li :class="{ active: isActive('/provider/provider-enquiry') }">
              <router-link to="/provider/provider-enquiry">
                <i class="ti ti-mail"></i><span>Enquiries</span>
              </router-link>
            </li>
            <li :class="{ active: isActive('/provider/provider-earnings') }">
              <router-link to="/provider/provider-earnings">
                <i class="ti ti-cash-banknote"></i><span>Earnings</span>
              </router-link>
            </li>
            <li :class="{ active: isActive('/provider/provider-chat') }">
              <router-link to="/provider/provider-chat">
                <i class="ti ti-messages"></i><span>Chat</span>
              </router-link>
            </li>

            <li>
              <a href="javascript:void(0);"
                :class="{ 'active subdrop': isActive('provider-appointment-settings')}"
                @click="toggleSubmenu">
                <i class="ti ti-settings"></i>
                <span>Settings</span>
                <span class="menu-arrow"></span>
              </a>
              <ul :style="{ display: isSubmenuOpen ? 'block' : 'none' }">
                <li :class="{ active: isActive('/provider-settings/provider-appointment-settings') }">
                  <router-link to="/provider-settings/provider-appointment-settings">
                    <i class="ti ti-chevrons-right me-2"></i>Appointment
                  </router-link>
                </li>
                <li :class="{ active: isActive('/provider-accounts-settings') }">
                  <router-link to="/provider-settings/provider-accounts-settings">
                    <i class="ti ti-chevrons-right me-2"></i>Account
                  </router-link>
                </li>
                <li :class="{ active: isActive('/provider-social-profile') }">
                  <router-link to="/provider-settings/provider-social-profile">
                    <i class="ti ti-chevrons-right me-2"></i>Social Profiles
                  </router-link>
                </li>
                <li :class="{ active: isActive('/provider-security-settings') }">
                  <router-link to="/provider-settings/provider-security-settings">
                    <i class="ti ti-chevrons-right me-2"></i>Security
                  </router-link>
                </li>
                <li :class="{ active: isActive('/provider-plan') }">
                  <router-link to="/provider-settings/provider-plan">
                    <i class="ti ti-chevrons-right me-2"></i>Plan & Billings
                  </router-link>
                </li>
                <li :class="{ active: isActive('/payment-settings') }">
                  <router-link to="/provider-settings/payment-settings">
                    <i class="ti ti-chevrons-right me-2"></i>Payment
                  </router-link>
                </li>
                <li :class="{ active: isActive('/provider-notifcations') }">
                  <router-link to="/provider-settings/provider-notifcations">
                    <i class="ti ti-chevrons-right me-2"></i>Notifications
                  </router-link>
                </li>
                <li :class="{ active: isActive('/provider-connected-apps') }">
                  <router-link to="/provider-settings/provider-connected-apps">
                    <i class="ti ti-chevrons-right me-2"></i>Connected Apps
                  </router-link>
                </li>
                <li :class="{ active: isActive('/verification') }">
                  <router-link to="/provider-settings/verification">
                    <i class="ti ti-chevrons-right me-2"></i>Profile Verification
                  </router-link>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    data-bs-toggle="modal"
                    data-bs-target="#del-account"
                  >
                    <i class="ti ti-chevrons-right me-2"></i>Delete Account
                  </a>
                </li>
              </ul>
            </li>

            <li>
              <router-link to="/">
                <i class="ti ti-logout-2"></i><span>Logout</span>
              </router-link>
            </li>
          </ul>
        </div>
      </perfect-scrollbar>
    </div>
  </div>
  <!-- /Sidebar -->
</template>

<script>
import { PerfectScrollbar } from "vue3-perfect-scrollbar";
import "vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css";
import { defineComponent, ref, watch } from "vue";
import { useRoute } from "vue-router";

export default defineComponent({
  data() {
    return {
      settings: {
        suppressScrollX: true,
      },
    };
  },
  methods: {
    scrollHanle(evt) {},
  },
  components: {
    PerfectScrollbar,
  },
  name: "ProviderNavigation",
  setup() {
    const route = useRoute();
    const isSubmenuOpen = ref(false); // Track if the submenu is open

    const isActive = (path) => {
      return route.path === path || route.path.startsWith(path + "/");
    };

    const toggleSubmenu = () => {
      isSubmenuOpen.value = !isSubmenuOpen.value;
    };

    // Automatically open submenu if any settings path is active
    watch(
      () => route.path,
      (newPath) => {
        isSubmenuOpen.value = [
          "/provider-appointment-settings",
          "/provider-accounts-settings",
          "/provider-social-profile",
          "/provider-security-settings",
          "/provider-plan",
          "/payment-settings",
          "/provider-notifications",
          "/provider-connected-apps",
          "/verification",
        ].some((subPath) => newPath.startsWith(subPath));
      }
    );

    return { isActive, isSubmenuOpen, toggleSubmenu };
  },
});
</script>
